export const MAX_COUNT_VISIBLE_ITEMS = 8;
export const GOOGLE_COPYRIGHT_IMAGE = 'https://maps.gstatic.com/mapfiles/api-3/images/powered-by-google-on-white3.png';
